// @flow strict
import * as React from 'react';
import { FormGrid, FormGridCell, FormGridRow, TextInput } from '@ansarada/ace-react';
import loadable from '@loadable/component';
// import AsyncPhoneInput from './PhoneNumberInput';

const AsyncPhoneInput = loadable(() => import('./PhoneNumberInput'));

const urlIpToCountry = 'https://ip2c.org/self';

export const ContactDetails = ({
  values,
  setFieldValue,
  setFieldTouchedByName,
  fieldStatusByName,
  touched,
  validateForm,
  errors,
}: any) => {
  const [defaultCountry, setDefaultCountry] = React.useState('');

  const getVisitorCountry = async () => {
    const response = await window.fetch(urlIpToCountry);
    const data = await response.text();
    const [status, country] = String(data).split(';');
    const visitorCountry = status === '1' && country !== 'ir' ? country : 'au';
    setDefaultCountry(visitorCountry);
  };

  React.useEffect(() => {
    validateForm();
    getVisitorCountry();
  }, []);

  return (
    <FormGrid>
      <FormGridRow>
        <FormGridCell
          labelText="Your first name"
          errors={touched.Firstname && errors.Firstname}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_AdvisorFirstName"
            required
            status={fieldStatusByName('Firstname') === 'Bad' ? 'Bad' : 'Good'}
            value={values.Firstname}
            onChangeValue={newVal => setFieldValue('Firstname', newVal)}
            onBlur={() => {
              setFieldTouchedByName('Firstname')();
            }}
          />
        </FormGridCell>
        <FormGridCell
          labelText="Your last name"
          errors={touched.Lastname && errors.Lastname}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_AdvisorLastName"
            required
            value={values.Lastname}
            status={fieldStatusByName('Lastname') === 'Bad' ? 'Bad' : 'Good'}
            onChangeValue={newVal => setFieldValue('Lastname', newVal)}
            onBlur={() => {
              setFieldTouchedByName('Lastname')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Your organization"
          errors={touched.Company && errors.Company}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_AdvisorCompanyName"
            status={fieldStatusByName('Company') === 'Bad' ? 'Bad' : 'Good'}
            placeholder="The name of the advisory firm you work for"
            value={values.Company}
            onChangeValue={newVal => setFieldValue('Company', newVal)}
            onBlur={() => {
              setFieldTouchedByName('Company')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Your email"
          errors={touched.Email && errors.Email}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_AdvisorEmail"
            value={values.Email}
            status={fieldStatusByName('Email') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('Email')();
            }}
            onChangeValue={newVal => {
              setFieldValue('Email', newVal);
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Your phone"
          errors={touched.PhoneNumber && errors.PhoneNumber}
          errorPosition="Bottom"
          hint="Optional"
          hintPosition="Bottom"
        >
          <AsyncPhoneInput
            labelId="DigitalQuoteForm_AdvisorPhoneNumber"
            value={values.PhoneNumber}
            onPhoneNumberChange={(isValid, val, countryData, fullNumber) => {
              setFieldValue('isPhoneValid', isValid, false);
              setFieldValue('PhoneNumber', val, false);
              setFieldValue('FullPhoneNumber', fullNumber);
            }}
            onSelectFlag={(currentNumber, countryData, fullNumber, isValid) => {
              setFieldValue('isPhoneValid', isValid, false);
              setFieldValue('FullPhoneNumber', fullNumber);
            }}
            onPhoneNumberBlur={() => {
              setFieldTouchedByName('PhoneNumber')();
              setFieldTouchedByName('isPhoneValid')();
            }}
            status={
              fieldStatusByName('PhoneNumber') === 'Bad' ||
              (touched.isPhoneValid && !values.isPhoneValid)
                ? 'Bad'
                : 'Good'
            }
            defaultCountry={defaultCountry}
          />
        </FormGridCell>
      </FormGridRow>
    </FormGrid>
  );
};
